module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'is-dark': _vm.darkThemeEnabled
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "navbar__container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('header', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('brand-logo', {
    attrs: {
      "light": ""
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    attrs: {
      "id": "main-nav"
    }
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('summoner-search')], 1)])])])])]), _vm._v(" "), _c('main', {
    staticClass: "section"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-burger",
    attrs: {
      "data-target": "main-nav"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427a9fc7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 399
// module chunks = 1